export function isValidUrl(str) {
  return str.match(
    /http(s)?:\/\/.?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
}



// WEBPACK FOOTER //
// ./app/utils/validate.js